import { render, staticRenderFns } from "./SingleTestDetalis.vue?vue&type=template&id=eee20e84&scoped=true"
import script from "./SingleTestDetalis.vue?vue&type=script&lang=js"
export * from "./SingleTestDetalis.vue?vue&type=script&lang=js"
import style0 from "./SingleTestDetalis.vue?vue&type=style&index=0&id=eee20e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee20e84",
  null
  
)

export default component.exports